import React from "react";
import SideBar from "../../components/Sidebar";
import { APP_INFO } from "../../constants/AppInfo";

const AboutUs = () => {
  return (
    <div>
      <div className="container-fluid mt-3">
        <div className="row">
          {/* Sidebar */}

          <SideBar />

          {/* Main Content */}
          <div className="col-md-9 mb-3">
            <div className="card mb-4 shadow-sm">
              <div className="card-body">
                <h5 className="card-title">About Us</h5>
                <div className="row">
                  {/* <PopularServices /> */}

                  <div className="container my-4">
                    <div className="row">
                      <div class="about-content">
                        <h6>Who We Are</h6>
                        <p>
                          FORMAX PAY is a brand of FORMAX IT SOLUTIONS PRIVATE
                          LIMITED (CIN: U72900WB2018PTC228240), a registered
                          company in India. The platform is designed to provide
                          a smooth and user-friendly experience for everyday
                          recharge and payment requirements. We offer essential
                          services such as Mobile Recharge, DTH Recharge, Google
                          Play Recharge, and Utility Bill Payments. Our system
                          is built to process transactions efficiently while
                          maintaining accuracy and consistency. Our goal is to
                          make these services easily accessible through a
                          structured platform that focuses on simplicity,
                          reliability, and convenience for all users.
                        </p>

                        <h6>Our Vision</h6>
                        <p>
                          To build a trusted and accessible platform for
                          recharge and bill payment services across India,
                          focusing on reliability and ease of use.
                        </p>

                        <h6>Our Mission</h6>
                        <p>
                          To provide a simple, secure, and efficient platform
                          for mobile recharge, DTH recharge, Google Play
                          recharge, and utility bill payments, ensuring a smooth
                          experience for every user.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default AboutUs;
